import { render, staticRenderFns } from "./SystemSettingsUpload.vue?vue&type=template&id=0037b108&scoped=true&"
import script from "./SystemSettingsUpload.vue?vue&type=script&lang=js&"
export * from "./SystemSettingsUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0037b108",
  null
  
)

export default component.exports